import { render, staticRenderFns } from "./CabinetEdit.vue?vue&type=template&id=02580f45&scoped=true&"
import script from "./CabinetEdit.vue?vue&type=script&lang=js&"
export * from "./CabinetEdit.vue?vue&type=script&lang=js&"
import style0 from "./CabinetEdit.vue?vue&type=style&index=0&id=02580f45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02580f45",
  null
  
)

export default component.exports